import { ICallParams } from '../../spa/components/call/types';
export class UrlUtil {

  public static getObjectFromQueryString(queryString: string): Record<string, any> {
    const items = queryString.split('&');
    const query = items.reduce<Record<string, any>>((acc, item) => {
      const [key, value] = item.split('=');
      acc[key] = value;
      return acc;
    }, {});
    return query;
  }

  public static getObjectFromUrl(url: string): Record<string, any> {
    const queryString = url.split('?')[1];
    return queryString ? UrlUtil.getObjectFromQueryString(queryString) : {};
  }

  public static getRoute(): string[] {
    return location.pathname.split('/'); // ['', video|audio, groupId, videoId]
  }

  public static getRouteCall(): ICallParams { // ['', call, roomId, isTeacher]
    // `/` is the call lobby (`/call` redirects here), served without a redirect so it can be indexed
    if (location.pathname === '/') {
      return { roomId: false, isTeacher: false };
    }
    const route = this.getRoute();
    if (!route || !route.length || route.length < 2 || route[1] !== 'call')
      return null as any;

    let roomId = route && route.length && route.length > 2 && route[2];
    let isTeacher = route && route.length && route.length > 3 && route[3] === 'true';

    return {
      roomId,
      isTeacher,
    };
  }

  // Routes whose page has no bootstrap of its own (unlike /authCallback) and needs
  // CallAppEvents.onLoad to establish a session on a hard reload.
  public static needsAuthBootstrap(): boolean {
    const path = location.pathname;
    return !!this.getRouteCall() || path.startsWith('/audio/');
  }
}
